var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0979 1.8541C21.6966 0.011477 24.3034 0.0114799 24.9021 1.8541L28.8374 13.9656C29.1051 14.7896 29.873 15.3475 30.7395 15.3475H43.4742C45.4117 15.3475 46.2172 17.8268 44.6498 18.9656L34.3472 26.4509C33.6462 26.9601 33.3529 27.8629 33.6206 28.6869L37.5559 40.7984C38.1546 42.641 36.0456 44.1732 34.4782 43.0344L24.1756 35.5492C23.4746 35.0399 22.5254 35.0399 21.8244 35.5492L11.5218 43.0344C9.95438 44.1732 7.84542 42.641 8.44413 40.7984L12.3794 28.6869C12.6471 27.8629 12.3538 26.9601 11.6528 26.4509L1.35021 18.9656C-0.217216 17.8268 0.588336 15.3475 2.52578 15.3475H15.2605C16.127 15.3475 16.8949 14.7896 17.1626 13.9656L21.0979 1.8541Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c8a4927597397a8125a99c4a75b2f5bb.svg";
export { ForwardRef as ReactComponent };